import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/analytics';
// Your web app's Firebase configuration
const config = {
  apiKey: 'AIzaSyB-AX9q3QBkL5BaLUcvFYg0D_2YNP2I6x8',
  authDomain: 'munlabs-com.firebaseapp.com',
  databaseURL: 'https://munlabs-com.firebaseio.com',
  projectId: 'munlabs-com',
  storageBucket: 'munlabs-com.appspot.com',
  messagingSenderId: '443263523087',
  appId: '1:443263523087:web:5382dc37a978f25ba0467a',
  measurementId: 'G-M6Q15F4BQE',
};

firebase.initializeApp(config);
firebase.analytics();
// Vue.prototype.$firebase = firebase;
// Vue.prototype.$auth = firebase.auth();

export default firebase;
